export class DreFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getDreTalhao(safraId, talhaoId, fazendaId) {
    return this.instance.get('/v1/relatorios/dre/dre-talhoes', {
      params: {
        safraId,
        talhaoId: Number(talhaoId),
        fazendaId,
      },
    });
  }

  getDreResumo(talhaoId, safraId) {
    return this.instance.get(`/v1/talhoes/${talhaoId}/dre/resumo`, {
      params: { safra: safraId },
    });
  }

  getReceitaEstimadaTalhao(safraId, talhaoId, fazendaId) {
    return this.instance.get('/v1/relatorios/dre/dre-talhoes', {
      params: {
        safraId,
        talhaoId: Number(talhaoId),
        fazendaId,
      },
    });
  }

  getDreDetalhamentoCustos(talhaoId, safraId) {
    return this.instance.get(`/v1/talhoes/${talhaoId}/dre/custos`, {
      params: { safra: safraId },
    });
  }
}

export default (...params) => new DreFactory(...params);
